<template>
  <div>
    <Card>
      <div slot="title">项目基本信息</div>
      <Button type="success" @click="back" size="small" slot="extra" v-if="showBack">
        <span> 返回项目列表 </span>
        <Icon type="chevron-right"></Icon>
      </Button>
      <div>
        <div class="info-item">
          <span>项目名称：{{ projectData.projectName }}</span>
        </div>
        <div class="info-item">
          <span>项目编号全称：{{ projectData.projectFull }}</span>
        </div>
        <div class="info-item">
          <span>项目简称：{{ projectData.projectShort }}</span>
        </div>
        <div class="info-item">
          <span>所属部门：{{ projectData.district }}</span>
        </div>
        <div class="info-item">
          <span>所属地区：{{ projectData.area }}</span>
        </div>
        <div class="info-item">
          <span>分子公司：{{ projectData.companyName }}</span>
        </div>
        <div class="info-item">
          <Button type="primary" size="small" @click="moreInfo=!moreInfo">
            <span v-show="moreInfo">简略</span>
            <span v-show="!moreInfo">详情</span>
          </Button>
        </div>
      </div>
      <div v-show="moreInfo">
        <div class="info-item">
          <span>当地编号：{{ projectData.localNumber }}</span>
        </div>
        <div class="info-item">
          <span>采购进出口：{{ projectData.import }}</span>
        </div>
        <div class="info-item">
          <span>是否有论证：{{ projectData.argument }}</span>
        </div>
        <div class="info-item">
          <span>采购方式：{{ projectData.buyerModes }}</span>
        </div>
        <div class="info-item">
          <span>业务范围：{{ projectData.businessType }}</span>
        </div>
        <div class="info-item">
          <span>项目性质：{{ projectData.projectProperty }}</span>
        </div>
        <div class="info-item">
          <span>招标平台：{{ projectData.bidPlatform }}</span>
        </div>
        <div class="info-item">
          <span>采购类别：{{ projectData.buyerNature }}</span>
        </div>
        <div class="info-item">
          <span>资金来源：{{ projectData.capitalSource }}</span>
        </div>
        <div class="info-item">
          <span>包组数量：{{ projectData.groupCount }}</span>
        </div>
        <div class="info-item">
          <span>预算金额：{{ projectData.purchaseBudget }}</span>
        </div>
        <div class="info-item">
          <span>资格标预计：{{ projectData.qualifyPredict }}</span>
        </div>
        <div class="info-item">
          <span>服务费类型：{{ projectData.serviceFeeType }}</span>
        </div>
        <div class="info-item" v-if="projectData.serviceFeeType==='折扣'">
          <span>折扣率：{{ projectData.discount }}%</span>
        </div>
        <div class="info-item">
          <span>预计服务费：{{ projectData.servicePredict }}</span>
        </div>
        <div class="info-item">
          <span>采购内容：{{ projectData.purchaseContent }}</span>
        </div>
        <div class="info-item">
          <span>采购人名称：{{ projectData.purchaserName }}</span>
        </div>
        <div class="info-item">
          <span>联系地址：{{ projectData.pAddress }}</span>
        </div>
        <div class="info-item">
          <span>联系方式：{{ projectData.pTel }}</span>
        </div>
        <div class="info-item">
          <span>采购联系人：{{ projectData.pContacts }}</span>
        </div>
        <div class="info-item">
          <span>采购人属性：{{ projectData.pAttr }}</span>
        </div>
        <div class="info-item">
          <span>客户所属行业：{{ projectData.clientSys }}</span>
        </div>
        <div class="info-item">
          <span>客户经理：{{ projectData.am }}</span>
        </div>
        <div class="info-item">
          <span>项目助理：{{ projectData.aid }}</span>
        </div>
        <div class="info-item">
          <span>立项时间：{{ projectData.newProjectTime | filterTime }}</span>
        </div>
        <div class="info-item">
          <span>应收款：{{ projectData.receivables }}</span>
        </div>
        <div class="info-item">
          <span>中标金额：{{ projectData.winMoney }}</span>
        </div>
        <div class="info-item">
          <span>跟进人员：{{ projectData.merchandiser }}</span>
        </div>
        <div class="info-item">
          <span>备注：{{ projectData.comment }}</span>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  props: {
    projectData: {
      type: Object
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moreInfo: false,
    }
  },
  methods: {
    back() {
      this.$emit('back')
    }
  },
  filters: {
    filterTime(val) {
      if (!val) return ''
      if (val) {
        return val.replace('T', ' ')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.info-item {
  min-width: 250px;
  margin: 5px 20px;
  display: inline-block;
}
</style>
